import { expect, waitUntil, aTimeout } from '@open-wc/testing';
import {
  executeServerCommand,
  sendKeys,
  sendMouse,
} from '@web/test-runner-commands';
import fetchMock from 'fetch-mock';
import '../src/testHarness.js';
import {
  apiCallKey,
  mockDataMeta,
  fixtureBeforeEach,
  fixtureBefore,
  fixtureAfterEach,
  TelemInfo,
  screenshotAndCompare,
} from './utils/helpers.js';

describe('delete notification', () => {
  before(async () => {
    await fixtureBefore();
  });

  beforeEach(async () => {
    await fixtureBeforeEach();
  });

  afterEach(async () => {
    fixtureAfterEach();
  });

  it('should close and re-open delete a notification', async () => {
    const deleteMousePos: [number, number] = await executeServerCommand(
      'mouseFocusInfo',
      {
        selector:
          'notification-item [data-testclass="delete-notification"]:not([disabled])',
        action: 'mouse',
      }
    );

    await sendMouse({
      type: 'click',
      position: deleteMousePos,
    });

    let deleteNotificationModalInfo: TelemInfo[] = await executeServerCommand(
      'mouseFocusInfo',
      {
        selector: '[data-testclass="notification-delete-confirmation"][open]',
        action: 'info',
      }
    );

    expect(deleteNotificationModalInfo.length).to.equal(1);

    await aTimeout(300);

    await executeServerCommand('mouseFocusInfo', {
      selector:
        '[data-testclass="notification-delete-confirmation"][open] ix-button[name="cancel"]',
    });

    await sendKeys({
      press: 'Space',
    });

    await aTimeout(300);

    deleteNotificationModalInfo = await executeServerCommand('mouseFocusInfo', {
      selector: '[data-testclass="notification-delete-confirmation"][open]',
      action: 'info',
    });

    expect(deleteNotificationModalInfo.length).to.equal(0);

    await sendMouse({
      type: 'click',
      position: deleteMousePos,
    });

    await aTimeout(300);

    deleteNotificationModalInfo = await executeServerCommand('mouseFocusInfo', {
      selector: '[data-testclass="notification-delete-confirmation"][open]',
      action: 'info',
    });

    expect(deleteNotificationModalInfo.length).to.equal(1);

    // test toggling the modal off of the background to make sure it it re-opens
    await sendMouse({
      type: 'click',
      position: [100, 100],
    });

    await aTimeout(300);

    deleteNotificationModalInfo = await executeServerCommand('mouseFocusInfo', {
      selector: '[data-testclass="notification-delete-confirmation"][open]',
      action: 'info',
    });

    expect(deleteNotificationModalInfo.length).to.equal(0);

    await sendMouse({
      type: 'click',
      position: deleteMousePos,
    });

    await aTimeout(300);

    deleteNotificationModalInfo = await executeServerCommand('mouseFocusInfo', {
      selector: '[data-testclass="notification-delete-confirmation"][open]',
      action: 'info',
    });

    expect(deleteNotificationModalInfo.length).to.equal(1);
  });

  it('should delete a notification', async () => {
    const mousePos: [number, number] = await executeServerCommand(
      'mouseFocusInfo',
      {
        selector:
          'notification-item [data-testclass="delete-notification"]:not([disabled])',
        action: 'mouse',
      }
    );

    await sendMouse({
      type: 'click',
      position: mousePos,
    });

    await screenshotAndCompare('remove-item-modal');

    await executeServerCommand('mouseFocusInfo', {
      selector:
        '[data-testclass="notification-delete-confirmation"][open] ix-button[name="confirm"]',
    });

    await screenshotAndCompare('delete-btn-focus-modal');

    await sendKeys({
      press: 'Space',
    });

    await waitUntil(
      () => {
        const lastCall = fetchMock.callHistory.lastCall(apiCallKey);
        return lastCall?.options.method === 'delete';
      },
      `${apiCallKey} API DELETE with call never made`,
      { interval: 10, timeout: 20000 }
    );

    const messageInfo: TelemInfo[] = await executeServerCommand(
      'mouseFocusInfo',
      {
        selector: '[data-testid="notification-delete-toast"]',
        action: 'info',
      }
    );

    expect(
      messageInfo[0].text.includes('Successfully deleted the notification')
    ).to.equal(true);

    const itemsInfo: TelemInfo[] = await executeServerCommand(
      'mouseFocusInfo',
      {
        selector: 'notification-item',
        action: 'info',
      }
    );

    expect(itemsInfo.length).to.equal(mockDataMeta.itemsCount - 1);
  });
});
